import React, {useState} from "react";

import Page from "../../layouts/Main/Page";
import RatePlanner from "./RatePlanner";
import RatePlans from "./RatePlans";
import RatesProvider from "./RateContext";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {TabContext, TabPanel} from "@mui/lab";
import {add, startOfDay} from "date-fns";


const MAX_MONTHS_FROM_TODAY = 18;
export const getLastDateToPlan = () => startOfDay(add(new Date(), {months: MAX_MONTHS_FROM_TODAY}));

const Rates = () => {
    return <RatesProvider>
        <RatesPage/>
    </RatesProvider>
}


const RatesPage = () => {
    const [selectedTab, setSelectedTab] = useState("0")

    return <>

        <Page title="Tariffe"
              disablePadding>
            <TabContext value={selectedTab}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs variant="scrollable"
                          aria-label="rates tabs"
                          value={selectedTab}
                          onChange={(e, newValue) => setSelectedTab(newValue)}>
                        <Tab label="Tariffe" value="0"/>
                        <Tab label="Piani Tariffari" value="1"/>
                    </Tabs>
                </Box>
                <TabPanel value="0" sx={{p:0, display: "flex", flexGrow: selectedTab === "0" ? 1 : 0}}>
                    <RatePlanner />
                </TabPanel>
                <TabPanel value="1" sx={{p:0}}>
                    <RatePlans />
                </TabPanel>
            </TabContext>
        </Page>
    </>
}

export default Rates;